const translations = {
  translation: {
    login: {
      loginTitle: 'Log In',
      emailLabel: 'Email Address / Username',
      emailError: 'Enter a valid Email Address or Username',
      emailPlaceholder: 'Enter your email or username',
      passwordLabel: 'Password',
      passwordError: 'Enter a valid password',
      passwordPlaceholder: 'Enter your password',
      credentialsError: 'Invalid credentials. Please try again.',
      tenantInactive:
        'This site is not available right now. Contact your administrator if you need access.',
      //TODO: check
      studentWithNoClasses:
        "You don't have any classes assigned to you. Please contact your administrator.",
      forgotPasswordButton: 'Forgot password?',
      signUpTitle: "Don't have an account?",
      signUpButton: 'Sign Up',
      coBrandPlus: '+',
      coBrandProductLogoAlt: 'Product logo',
      coBrandPartnerLogoAlt: 'Organization logo',
      lockedTitle: 'Account Temporarily Locked',
      lockedDescription:
        'You have exceeded the maximum allowed failed login attempts ({{failed}} of {{max}}). For your security, account access has been temporarily locked.',
      lockedTryAgain: 'Please try again in:',
      lockedIllustrationAlt: 'Account security illustration',
    },
    recoverPassword: {
      title: 'Recover Password',
      text: "Enter your email address or username below, we'll send you an email with a link to reset your password.",
      identifierLabel: 'Email Address / Username',
      identifierError: 'Enter a valid Email Address or Username',
      identifierPlaceholder: 'Enter your email or username',
      sendButton: 'Send Email',
    },
    successRecovery: {
      title: 'Check Your Email Inbox!',
      text: "You're almost done! Find the email we sent you and use the link to reset your password.",
      button: 'Got it',
    },
    resetPassword: {
      title: 'Enter a new password',
      passwordLabel: 'New Password',
      passwordPlaceholder: 'Enter your new password',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your new password',
      previouslyUsedError: 'Choose a password you have not used recently.',
      policyViolationError:
        'Your password does not meet the current password requirements.',
      passwordMatchError: 'The passwords do not match.',
      submitButton: 'Reset Password',
      errorMessage: 'Uh Oh! Something went wrong. Please try again.',
    },
    successResetPassword: {
      title: 'Success!',
      text: 'Your new password is ready to use!',
      button: 'Continue',
    },
    expiredResetPassword: {
      title: 'Link Expired',
      text: 'This link has expired, please request a new one.',
      button: 'Recover Password',
    },
    signup: {
      alreadyHaveAccount: {
        title: 'Do you already have an account?',
        button: 'Log In',
      },
      setUpLogin: {
        title: 'Please create your account',
        emailLabel: 'Email Address {{domains}}',
        emailName: 'your.name@{{domain}}',
        emailSeparator: ' or ',
        emailPlaceholder: 'Enter your email address',
        emailFormatError: 'Please enter a valid email address',
        emailDomainError:
          'Oops! Use your email ending in {{domains}} to continue.',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Create your password',
        confirmPasswordLabel: 'Confirm Password',
        confirmPasswordPlaceholder: 'Confirm your password',
        passwordMatchError: 'The passwords do not match.',
        primaryButtonText: 'Continue',
        termsCheckboxText: "I've read and accept the",
        termsAndConditions: 'Terms & Conditions',
        and: 'and',
        privacyPolicy: 'Privacy Policy',
      },
      teacherAccount: {
        title: 'Welcome to',
        subtitle: 'Create your Educator Account',
        emailLabel: 'Email Address (your.name@school.edu)',
      },
      user: {
        title: "Before we talk dollars, let's talk names...",
        description:
          "We'll need your name to personalize your journey to money-smart greatness.",
        firstNameLabel: 'First Name',
        firstNamePlaceholder: 'Enter your first name',
        lastNameLabel: 'Last Name',
        lastNamePlaceholder: 'Enter your last name',
        primaryButtonText: 'Create Account',
        maxLengthError:
          'First Name and Last Name must be less than 50 characters',
      },
      verifyEmail: {
        title: 'Verify Your Email',
        descriptionPartOne:
          "We've sent a verification link to {{email}}. To finish setting up your account, just click the link in that email.",
        descriptionPartTwo:
          "Can't find it? Check your spam or junk folder — or click below to send it again.",
        primaryButtonText: 'Resend Verification Email',
        primaryButtonTextWithCountDown:
          'Resend Verification Email {{countDown}}',
        successMessage: 'Verification email sent!',
      },
      emailVerification: {
        success: {
          title: 'Your account has been successfully created!',
          description:
            'Welcome aboard! Your email has been verified and your account is now active. You can now start your financial journey.',
          primaryButtonText: 'Continue',
        },
        failed: {
          title: 'Email Verification Failed',
          description:
            'We couldn’t verify your email because the link is invalid or has expired. Please request a new verification email and try again.',
          primaryButtonText: 'Resend Verification Email',
          primaryButtonTextWithCountDown:
            'Resend Verification Email {{countDown}}',
          successMessage: 'Verification email sent!',
        },
      },
      successAccountCreated: {
        title: 'Your account has been successfully created!',
        description:
          'Welcome aboard! You can now start your financial journey.',
        primaryButtonText: 'Continue',
      },
      errorMessage: 'Something went wrong. Try again',
      claim: {
        title: 'Hi {{firstName}} {{lastName}}!',
        subtitle: 'Please create your account',
        emailLabel: 'Email Address',
        primaryButtonText: 'Create Account',
      },
    },
    invite: {
      title: '{{user}} Invited You to a Financial Education Adventure!',
      text: 'Get ready to learn the secrets of money, avoid debt disasters, and become the budgeting genius your future self will thank you for.',
      defaultTitle: 'Join the Learning Squad!',
      defaultText:
        "Hey there! Looks like the invite got a bit lost, so we don't know who sent you this link. No worries! You can still dive into our online classroom and unlock all its amazing resources. Just a heads-up: your friend won't get any referral benefits since we don't know who they are.",
      button: 'Join the Classroom',
      alreadyHaveAccountError: {
        title:
          'Welcome back {{firstName}}! It looks like you already have an account with us.',
        subtitle:
          "Your friend's referral is appreciated, however you can log in with your existing credentials to continue.",
        button: 'Access Your Dashboard Here',
      },
    },
    sessionExpiredError: {
      title: 'Uh Oh!',
      subtitle: 'Your session has expired.',
      button: 'Go Back to Log In',
    },
    siteUnavailable: {
      title: 'Site unavailable',
      subtitle:
        'This organization is not open right now. Please check back later or contact your administrator.',
    },
    somethingWentWrongError: {
      title: 'Something Went Wrong...',
      subtitle: 'Please try again.',
      subtitleTeacherSignUp:
        "We're hitting a little snag. Feel free to give it another shot right now or come back and try again later.",
      button: 'Go Back',
    },
    passwordRules: {
      length: 'At least {{min}} characters ({{min}} – {{max}})',
      upperAndLower: 'At least 1 uppercase and 1 lowercase letter',
      numberOrSymbol: 'At least 1 number (0 – 9) or symbol',
      spacesAllowed: 'Blank spaces allowed (passphrases)',
      noSpaces: 'No spaces allowed',
      loadingRequirements: 'Loading password requirements…',
      loadError: 'Password requirements could not be loaded. Please try again.',
    },
    hasNoSeatsError: {
      title: "Halt! You've Hit a Full House! 🛑",
      subtitle:
        "Zero seats left! Our classroom is maxed out. Keep your eyes peeled and try again soon—we're working on making room for more awesome students!",
    },
    expiredTokenError: {
      title: 'Oops! This link is either expired or just plain invalid.',
      subtitle: 'Time to snag a fresh one!',
      button: 'Get New Link',
      successMessage:
        "We've sent a new activation link to your email. Please check your inbox.",
      errorMessage: 'Something went wrong. Please try again.',
    },
    splash: {
      welcome: 'Welcome to',
      moneylingo: 'Moneylingo',
      for: 'for',
      poweredBy: 'powered by',
      buttonLabel: "Let's make money moves",
    },
  },
};

export default translations;
